<mon-page-layout
    [header]="'adminPerformanceProfiles.page.header' | transloco">
    <div subheader data-test="admin-performance-profiles-subheader">
        <span>{{ 'adminPerformanceProfiles.page.subHeader' | transloco }}</span>
        @if (!loading) {
            <span>{{ 'adminPerformanceProfiles.page.subHeader{{availableProfiles}}' | transloco:{availableProfiles} }}</span>
        }
    </div>
    <mon-table-wrapper
            [value]="performanceProfiles"
            [headers]="[
                TABLE_SCHEMA.NAME,
                TABLE_SCHEMA.DESCRIPTION,
                TABLE_SCHEMA.STATUS,
                TABLE_SCHEMA.ACTIONS
            ]"
            [total]="total"
            [currentPage]="currentPage"
            [perPage]="perPage"
            [loading]="loading"
            [fixedTableLayout]="true"
            [emptyMessage]="(isArchived ? 'adminPerformanceProfiles.table.emptyArchivedMessage' : 'adminPerformanceProfiles.table.emptyMessage') | transloco"
            (page)="onPageChange($event)"
            tableKey="admin-performance-profiles"
            data-test="admin-performance-profiles-table">
        <ng-container monTableLeft>
            <p-toggleswitch [(ngModel)]="isArchived"
                            (onChange)="onToggleShowOnlyArchivedProfiles($event)"
                            inputId="toggle-archive-status"
                            data-test="admin-performance-profiles-toggle-archive-status" />
            <label for="toggle-archive-status" class="tw-pl-3">{{ 'adminPerformanceProfiles.page.toggleArchiveStatusBtnLabel' | transloco }}</label>
        </ng-container>
        <ng-container monTableRight>
            <p-button data-test="admin-performance-profiles-add-button"
                      [label]="'adminPerformanceProfiles.page.addProfileBtnLabel' | transloco"
                      icon="pi pi-plus"
                      (onClick)="addProfile()"
            />
        </ng-container>
        <ng-container *monTableCellTemplate="TABLE_SCHEMA.STATUS; let profile">
            @if (profile.archived_at) {
                <span data-test="admin-performance-profiles-status-tableCell">{{ 'adminPerformanceProfiles.table.statusArchived' | transloco }}</span>
            } @else {
                <span data-test="admin-performance-profiles-status-tableCell">{{ 'adminPerformanceProfiles.table.statusActive' | transloco }}</span>
            }
        </ng-container>
        <ng-container *monTableCellTemplate="TABLE_SCHEMA.ACTIONS; let profile">
            <p-button
                    [ariaLabel]="'adminPerformanceProfiles.table.actionMenuBtnAriaLabel{{profileName}}' | transloco:{profileName: profile.name}"
                    data-test="admin-performance-profiles-actions-button"
                    icon="pi pi-ellipsis-v"
                    [rounded]="true"
                    [text]="true"
                    (onClick)="menu.toggle($event)" />
            <p-menu data-test="admin-performance-profiles-actions-menu"
                    appendTo="body"
                    #menu
                    [popup]="true"
                    [model]="profile.actionItems"
                    (onHide)="onMenuHide()">
            </p-menu>
        </ng-container>
    </mon-table-wrapper>
</mon-page-layout>
